import { render } from "./BorderBlockEndColor.vue?vue&type=template&id=f9791930&scoped=true&ts=true"
import script from "./BorderBlockEndColor.vue?vue&type=script&lang=ts"
export * from "./BorderBlockEndColor.vue?vue&type=script&lang=ts"

import "./BorderBlockEndColor.vue?vue&type=style&index=0&id=f9791930&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9791930"]])

export default __exports__